<template>
  <div class="form-group boolean rwce_program_consent">
    <div class="checkbox">
      <label
        class="program-consent-label"
        for="rugby-promo-consent-checkbox"
      >
        <input
          id="rugby-promo-consent-checkbox"
          v-model="acceptedRwceProgramConsent"
          class="rugby-promo-consent-checkbox"
          type="checkbox"
          name="rwce_program_consent_checkbox"
          @change="updateRwceProgramConsent"
        >
        <span class="custom-checkbox" />
        <div class="program-consent-text-wrapper">
          <!-- eslint-disable vue/no-v-html -->
          <span
            class="program-consent-text"
            v-html="$t('creditCardForm.rwceProgramConsent')"
          />
          <!-- eslint-enable -->
        </div>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProgramConsentCheckbox',
  emits: ['update-rugby-promo-consent'],
  data() {
    return {
      acceptedRwceProgramConsent: false
    }
  },
  methods: {
    updateRwceProgramConsent() {
      this.$emit('update-rugby-promo-consent', this.acceptedRwceProgramConsent)
    }
  },
}

</script>